export default function Header({ children }) {
	return (
		<header className="h-16 bg-linear-to-b shadow-md from-emerald-600 to-emerald-900 px-4" data-sentry-component="Header" data-sentry-source-file="index.jsx">
			{children}
		</header>
	);
}
